import { createContext, useContext } from "react";

import {
  FALLBACK_LOCALE,
  messages,
  type Locale,
  type MessageKey,
} from "./messages";

export type Translate = (key: MessageKey) => string;

export interface LocaleValue {
  locale: Locale;
  t: Translate;
}

export const LocaleContext = createContext<LocaleValue>({
  locale: FALLBACK_LOCALE,
  t: (key) => messages[key][FALLBACK_LOCALE],
});

export function useLocale(): LocaleValue {
  return useContext(LocaleContext);
}

export function useT(): Translate {
  return useContext(LocaleContext).t;
}
